import React from 'react'

import {
  arrayOf, shape, string, bool,
} from 'prop-types'

function ItemPageBreadcrumbs({ breadcrumbs }) {
  if (breadcrumbs.length < 1) {
    return null
  }

  return (
    <div className="item-page-breadcrumbs">
      <ul className="item-page-breadcrumbs__list" itemType="http://schema.org/BreadcrumbList" itemScope>
        {breadcrumbs.map((item, index) => (
          <React.Fragment key={item.title}>
            <li
              itemProp="itemListElement"
              itemType="http://schema.org/ListItem"
              itemScope
            >
              {!item.isActive ? (
                <a href={item.url} itemProp="item" className="item-page-breadcrumbs__link">
                  <span itemProp="name">{item.title}</span>
                </a>
              ) : (
                <span itemProp="name" className="item-page-breadcrumbs__current-item">
                  {item.title}
                  <meta itemProp="item" content={item.url} />
                </span>
              )}
              <meta itemProp="position" content={index + 1} />
            </li>
            {index !== breadcrumbs.length - 1 && <li className="item-page-breadcrumbs__slash">/</li>}
          </React.Fragment>
        ))}
      </ul>
    </div>
  )
}

ItemPageBreadcrumbs.propTypes = {
  breadcrumbs: arrayOf(
    shape({
      title: string.isRequired,
      url: string,
      isActive: bool,
    }),
  ).isRequired,
}

export default ItemPageBreadcrumbs
